import type { TargetGroupTemplate } from '../../types';

/** One line describing what a template holds, from its own fields (no extra requests). */
export const summarise = (t: TargetGroupTemplate, countryName?: string) => {
  const b = t.basicSetting;
  const parts: string[] = [];
  if (b) {
    if (countryName) parts.push(countryName);
    if (b.ageMinLimit != null && b.ageMaxLimit != null) parts.push(`ages ${b.ageMinLimit}–${b.ageMaxLimit}`);
    if (b.gender) parts.push(String(b.gender));
    if (b.noOfWantedCompletes != null) parts.push(`${b.noOfWantedCompletes} completes`);
  }
  return parts.join(' · ');
};

/** Which sections a template carries, for the little chips under its name. */
export const templateParts = (t: TargetGroupTemplate) => [
  t.basicSetting && 'Basics',
  t.region && ((t.region.stateIds || []).length || (t.region.cityIds || []).length || (t.region.wholeStateIds || []).length) && 'Regions',
  (t.profilingAnswerIds || []).length > 0 && 'Profiling',
  t.quotaSettings && ((t.quotaSettings.data || []).length > 0) && 'Quotas',
].filter(Boolean) as string[];
